module.exports = __webpack_public_path__ + "static/img/map.f851133.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/map.png
// module id = 81
// module chunks = 0